import { render, staticRenderFns } from "./InventoryModal.vue?vue&type=template&id=245215d0&scoped=true"
import script from "./InventoryModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./InventoryModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245215d0",
  null
  
)

export default component.exports